import { combineReducers } from 'redux';
import auth from './auth';
import playgrounds from './playgrounds';
import users from './users';
import bookings from './bookings';
import centers from './centers';
import sports from './sports';
import covers from './covers';
import api from './../lib/api';
import bookingTypes from './bookingTypes';
import timezone from './timezone';

import { INIT } from './app';

export default combineReducers({
  auth,
  centers,
  playgrounds,
  sports,
  covers,
  bookingTypes,
  bookings,
  users,
  timezone,
});

const loadWithRetry = (fn, label) =>
  fn().catch((e) => {
    console.error(`${label}:`, e);
    return new Promise((resolve) => setTimeout(resolve, 400)).then(() =>
      fn().catch((e2) => {
        console.error(`${label} (повтор):`, e2);
        return [];
      })
    );
  });

export const initApp = async (userRole) => {
  // Модератору не загружаем пользователей — вкладки «Пользователи» нет, getUsers() возвращает 403
  const loadUsers = userRole === 'administrator';
  // Клубы и площадки по очереди: параллельный GET на старом API часто даёт Failed to fetch.
  const centersRes = await loadWithRetry(() => api.getCenters(), 'Ошибка загрузки центров');
  const playgroundsRes = await loadWithRetry(() => api.getPlaygrounds(), 'Ошибка загрузки площадок');
  const [bookingsRes, timezoneRes, usersRes] = await Promise.all([
    api.getBookings().catch((e) => {
      console.error('Ошибка загрузки бронирований:', e);
      return [];
    }),
    api.getTimezoneList().catch((e) => {
      console.error('Ошибка загрузки таймзон:', e);
      return [];
    }),
    loadUsers
      ? api.getUsers().catch((e) => {
          console.error('Ошибка загрузки пользователей:', e);
          return [];
        })
      : Promise.resolve([]),
  ]);

  return {
    type: INIT,
    payload: {
      centers: centersRes,
      playgrounds: playgroundsRes,
      bookings: bookingsRes,
      users: usersRes,
      timezoneList: timezoneRes,
    },
  };
};
